<h2>
    <ng-container [ngSwitch]="selectedType">
        <ng-template ngSwitchCase="file">
            {{ 'HEADERS.SELECT_FILE' | translate }}
        </ng-template>
        <ng-template ngSwitchCase="collection">
            {{ 'HEADERS.SELECT_COLLECTION' | translate }}
        </ng-template>
        <ng-template ngSwitchCase="folder">
            {{ 'HEADERS.SELECT_FOLDER' | translate }}
        </ng-template>
    </ng-container>
</h2>

<div class="row">
    <div class="col">

        <div *ngIf="selects" class="selected-box gbo_shadow">
            <h3 *ngIf="!isMultiple">{{ 'MODALS.TEXT.OBJECT_INFO' | translate }}</h3>
            <h3 *ngIf="isMultiple">{{ 'MODALS.TEXT.OBJECTS_INFO' | translate }}</h3>

            <div *ngIf="!selects.length">
                <i>{{ 'MODALS.TEXT.NOT_SELECTED' | translate }}</i>
            </div>
            <div *ngIf="selects.length" class="selected-item">
                <div *ngFor="let item of selects; let i = index">
                    <i *ngIf="item.type_str === 'folder'" class="icon-folder"></i>
                    <i *ngIf="item.type_str === 'file'" class="icon-file"></i>
                    <i *ngIf="item.type_str === 'collection'" class="icon-bookmarks"></i>
                    <strong class="ms-2">#{{ i + 1 }}. {{ item.name }}</strong>
                    <i (click)="removeSelectItem(item)" class="bi bi-trash ms-1"
                       style="cursor: pointer"></i>
                    <div>{{ item.description }}</div>
                </div>
            </div>
            <button (click)="submitItem()"
                    class="btn btn-primary float-end">{{ 'BUTTON_TEXT.SELECT' | translate }}
            </button>
        </div>


        <app-component-button-create-fcfv
                [isCollection]="isCollection"
                [isCreateCollection]="isCreateCollection"
                [isCreateFolder]="isCreateFolder"
        ></app-component-button-create-fcfv>

        <div class="navigator" [style.max-height]="maxHeight">
            <app-component-folder-and-file-table
                    (eventClick)="onEventTrClick($event)"
                    (eventFind)="onEventFind($event)"
                    (eventSelected)="onEventTrSelected($event)"
                    [$mediator]="controller.$mediator"
                    [isSelected]="true"
                    view="mini"
            ></app-component-folder-and-file-table>
        </div>
    </div>
</div>
